import { render, staticRenderFns } from "./ChinaMap.vue?vue&type=template&id=1cb19efa&scoped=true&"
import script from "./ChinaMap.vue?vue&type=script&lang=js&"
export * from "./ChinaMap.vue?vue&type=script&lang=js&"
import style0 from "./ChinaMap.vue?vue&type=style&index=0&id=1cb19efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb19efa",
  null
  
)

export default component.exports